import SmartWordsLibraryUploadModalComponent from './component';
export default class SmartWordsLibraryUploadModalRoute extends SmartWordsLibraryUploadModalComponent {

}